import { render } from "./privacy.vue?vue&type=template&id=41eadd8b&scoped=true"
import script from "./privacy.vue?vue&type=script&lang=js"
export * from "./privacy.vue?vue&type=script&lang=js"

import "./privacy.vue?vue&type=style&index=0&id=41eadd8b&scoped=true&lang=css"

import exportComponent from "/Users/ezink/Downloads/vue-antd-tool-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41eadd8b"]])

export default __exports__